// @ts-nocheck
import { AdjustTermKey, AdjustTerms, PairedSalesAnalysisFeature } from '@aloft/toolkit-shared';
import { Typography } from '@aloft/toolkit-sui';

import {
  CustomTPColumn,
  SystemAccessorTPColumnKey,
  TPColumnKey,
} from '../../../../components/ToolkitPropertyTable/types.js';
import { proximityFormat } from '../../../../utils/proximityFormat.js';
import { proximityMiles } from '../../../../utils/proximityMiles.js';
import { isPairedSalesCustomAnalysisFeature } from '../../utils/isPairedSalesCustomAnalysisFeature.js';
import { getColumnDefForTerm } from './getColumnDefForTerm.js';
import { PairedSalesTableRow } from './types.js';

const leftColumns: TPColumnKey[] = ['address'];

const rightColumns: (TPColumnKey | SystemAccessorTPColumnKey | AdjustTermKey)[] = [
  'site',
  'grossLivingArea',
  'aboveGradeBedroomCount',
  'baths',
  'yearBuilt',
  'garageParkingSpacesCount',
  'dateOfSale',
  'salePrice',
  'listingStatus',
  'listingID',
];

function getRightColumns(
  selectedTerm: PairedSalesAnalysisFeature,
): CustomTPColumn<PairedSalesTableRow>[] {
  const columns: CustomTPColumn<PairedSalesTableRow>[] = [];
  for (const key of rightColumns) {
    const isTerm = Object.keys(AdjustTerms).includes(key);
    if (isTerm && key === selectedTerm) continue;
    if (isTerm) {
      columns.push(...getColumnDefForTerm(key as AdjustTermKey));
    } else {
      columns.push(key as TPColumnKey);
    }
  }

  return columns;
}

/** Creates a column for the selected term if it's not a default column. Always shows the selected term in the second column. */
export function getTableColumns(
  term: PairedSalesAnalysisFeature,
): CustomTPColumn<PairedSalesTableRow>[] {
  return [
    ...leftColumns,
    ...(isPairedSalesCustomAnalysisFeature(term) ? [] : getColumnDefForTerm(term)),
    {
      id: 'custom$proximity',
      title: 'Proximity',
      selector: (x: PairedSalesTableRow) => proximityMiles({ ...x.p1 }, { ...x.p2 }),
      toCell: (x: number | undefined) => (
        <Typography variant="tableH2" truncate>
          {proximityFormat(x)}
        </Typography>
      ),
      sortBy: (a: number | undefined, b: number | undefined) =>
        a === b ? 0 : (a ?? -Infinity) - (b ?? -Infinity),
    },
    ...getRightColumns(term),
  ];
}
